export const sum = (numbers: number[]) =>
  numbers.reduce((acc, n) => acc + n, 0);
